<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_date: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
      totals:{
        totalin:0,
        totalout:0,
    },
    };
  },
  computed: {
    ...mapGetters("stock", [
        "SuppliersBalanceDetails"
    ]),
  },
  methods: {
    ...mapActions({
        FetchBalanceDetails: "stock/fetchDescriptiveSuppliersBalanceDetails",
    }),
  },

  watch: {
    SuppliersBalanceDetails(newValue){
      if(newValue == true){
        this.FetchBalanceDetails();
      }
    }
  },

  updated() {
    let total_in = 0;
        let total_out = 0;
        if(this.SuppliersBalanceDetails){
          this.SuppliersBalanceDetails.forEach((item)=>{
              total_in = total_in+parseInt(item.amountIn);
          });
          this.totals.totalin = total_in;
          this.SuppliersBalanceDetails.forEach((item)=>{
              total_out = total_out+parseInt(item.amountOut);
          });
          this.totals.totalout = total_out;

          setTimeout(() => {
              window.onafterprint = window.close;
              window.print();
              window.history.back();
          }, 2000)          
        }
  },
  created() {
    this.FetchBalanceDetails(atob(this.$route.params.id));
  },
};
</script>

<style scoped>
/* .print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
} */
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">       

        <div class="bg-white p-2">
          <div class="print-font" style="padding-left: 15px">
            <table width="100%" class="mt-3">
                <b-spinner
                    v-if="!SuppliersBalanceDetails || SuppliersBalanceDetails.length==0"
                    class="m-0"
                    variant="primary"
                    role="status"
                ></b-spinner>
                <tr v-else>
                <td width="100%" style="text-align: right; padding-right: 15px !important">
                  <center>
                    <img v-if="SuppliersBalanceDetails[0].business.Businesslogo" :src="SuppliersBalanceDetails?SuppliersBalanceDetails[0].business.Businesslogo:''" height="80" /> 
                    <strong style="font-size: 25px; text-transform: uppercase">
                    {{
                      SuppliersBalanceDetails ? SuppliersBalanceDetails[0].business.name : "---"
                    }}</strong
                  >
                  <p style="font-size: 22px;">
                    <span>
                      {{
                        SuppliersBalanceDetails ? SuppliersBalanceDetails[0].business.address : "---"
                      }}</span
                    >
                    <br />
                    <strong>Tel: </strong
                    >{{
                      SuppliersBalanceDetails
                        ? "+256" + SuppliersBalanceDetails[0].business.phone1
                        : "---"
                    }}
                    <br />
                    <strong>Email: </strong
                    >{{ SuppliersBalanceDetails ? SuppliersBalanceDetails[0].business.email : "---" }}
                  </p>
                  </center>
                </td>
              </tr>
            </table>
            <hr style="border-style: dashed; width: 97%" />
            <h5
              style="
                text-align: center;
                font-weight: bold;
                font-family: Courier New, Courier, Lucida Sans Typewriter,
                  Lucida Typewriter, monospace;
              "
            >
              <span>
                <strong>
                  CUSTOMER PAYMENT REPORT
                  <br/> FOR {{ SuppliersBalanceDetails[0].supplier.name.toUpperCase() }} - {{ SuppliersBalanceDetails[0].supplier.contact }}<br/>
                  AS OF {{ current_date }}
                </strong>
              </span>
              <br />
            </h5>
            <h4>Details</h4>
            <center>
              <table width="100%" class="table" style="font-size: 15px">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Amount Received</th>
                    <th>Amount In</th>
                    <th>Amount Out</th>                    
                    <th>Balance</th>
                    <th>Paid Via</th>
                    <th>Description</th>
                    <th>Category</th>                    
                    <th>Recorded On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, r) in SuppliersBalanceDetails" :key="r">
                    <td>{{ r + 1 }}</td>
                    <td>{{ record.amount.toLocaleString() }}</td>
                    <td>{{ record.amountIn.toLocaleString() }}</td>
                    <td>{{ record.amountOut.toLocaleString() }}</td>                    
                    <td>{{ record.newbalance }}</td>
                    <td>{{ record.mode }}</td>
                    <td>{{ record.Description }}</td>                    
                    <td>{{ record.Category }}</td>                    
                    <td>{{ record.date }}</td>
                  </tr>
                </tbody>
              </table>
            </center>
            <span class="row text-center">
                <h5>Total In: <span class="text-danger">{{totals.totalin?(totals.totalin).toLocaleString():0}}</span></h5>
               
                <h5>Total Out: <span class="text-danger">{{totals.totalout?(totals.totalout).toLocaleString():0}}</span></h5>

                <h5>Total Balance: <span class="text-danger">{{(totals.totalout - totals.totalin)?(totals.totalout - totals.totalin).toLocaleString():0}}</span></h5>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
